import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white shadow-sm" }
const _hoisted_3 = {
  class: "card-header d-flex justify-content-between align-items-center py-4 px-4",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_4 = { class: "text-white fw-bold mb-1" }
const _hoisted_5 = { class: "text-white opacity-75" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-30 letter-spacing" }
const _hoisted_7 = { class: "row g-4 mb-5" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "mb-0" }
const _hoisted_14 = { class: "col-md-4" }
const _hoisted_15 = { class: "mb-0" }
const _hoisted_16 = { class: "col-md-4" }
const _hoisted_17 = { class: "mb-0" }
const _hoisted_18 = { class: "row g-4 mb-5" }
const _hoisted_19 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_20 = { class: "mb-0" }
const _hoisted_21 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_22 = { class: "mb-0" }
const _hoisted_23 = {
  key: 2,
  class: "col-md-3"
}
const _hoisted_24 = { class: "mb-0" }
const _hoisted_25 = {
  key: 3,
  class: "col-md-3"
}
const _hoisted_26 = { class: "mb-0" }
const _hoisted_27 = { class: "row g-4 mb-5" }
const _hoisted_28 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_29 = { class: "mb-0" }
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = { class: "mb-0" }
const _hoisted_32 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = { class: "mb-0" }
const _hoisted_35 = { class: "col-md-4" }
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = { class: "col-md-4" }
const _hoisted_38 = { class: "mb-0" }
const _hoisted_39 = { class: "col-md-4" }
const _hoisted_40 = { class: "mb-0" }
const _hoisted_41 = {
  key: 1,
  class: "col-12"
}
const _hoisted_42 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_43 = { class: "mb-4" }
const _hoisted_44 = { class: "text-primary fw-bold border-bottom pb-2" }
const _hoisted_45 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_46 = {
  class: "accordion",
  id: "blAccordion"
}
const _hoisted_47 = { class: "accordion-header" }
const _hoisted_48 = ["data-bs-target", "aria-expanded", "aria-controls"]
const _hoisted_49 = { class: "badge bg-white text-primary ms-3" }
const _hoisted_50 = {
  key: 0,
  class: "badge bg-white text-primary ms-2"
}
const _hoisted_51 = ["id"]
const _hoisted_52 = { class: "accordion-body p-0" }
const _hoisted_53 = {
  key: 0,
  class: "p-3"
}
const _hoisted_54 = { class: "table-responsive" }
const _hoisted_55 = { class: "table table-hover align-middle mb-0" }
const _hoisted_56 = { class: "text-center" }
const _hoisted_57 = { class: "text-center" }
const _hoisted_58 = { class: "text-end" }
const _hoisted_59 = { class: "text-end" }
const _hoisted_60 = { class: "text-end" }
const _hoisted_61 = { class: "text-end" }
const _hoisted_62 = { class: "text-end" }
const _hoisted_63 = {
  key: 1,
  class: "p-3 bg-light border-top text-center"
}
const _hoisted_64 = ["onClick"]
const _hoisted_65 = {
  key: 2,
  class: "text-center text-muted py-4"
}
const _hoisted_66 = {
  key: 1,
  class: "text-center text-muted py-4"
}
const _hoisted_67 = {
  key: 3,
  class: "modal fade show d-block",
  tabindex: "-1"
}
const _hoisted_68 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_69 = { class: "modal-content" }
const _hoisted_70 = {
  class: "modal-header",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_71 = { class: "modal-title text-white" }
const _hoisted_72 = { class: "modal-body p-4" }
const _hoisted_73 = { class: "row g-3" }
const _hoisted_74 = { class: "card border-primary h-100 shadow-sm" }
const _hoisted_75 = { class: "card-header bg-primary text-white" }
const _hoisted_76 = { class: "card-body" }
const _hoisted_77 = { class: "mb-3 pb-3 border-bottom" }
const _hoisted_78 = { class: "mb-0 fw-bold text-primary fs-5" }
const _hoisted_79 = { class: "row g-3" }
const _hoisted_80 = { class: "col-4" }
const _hoisted_81 = {
  key: 0,
  class: "mb-0 text-dark fw-bold"
}
const _hoisted_82 = {
  key: 1,
  class: "mb-0 text-muted small fst-italic"
}
const _hoisted_83 = { class: "col-4" }
const _hoisted_84 = {
  key: 0,
  class: "mb-0 text-dark fw-bold"
}
const _hoisted_85 = {
  key: 1,
  class: "mb-0 text-muted small fst-italic"
}
const _hoisted_86 = { class: "col-4" }
const _hoisted_87 = {
  key: 0,
  class: "mb-0 text-dark fw-bold"
}
const _hoisted_88 = {
  key: 1,
  class: "mb-0 text-muted small fst-italic"
}
const _hoisted_89 = { class: "modal-footer bg-light" }
const _hoisted_90 = { class: "mb-4" }
const _hoisted_91 = { class: "text-primary fw-bold border-bottom pb-2" }
const _hoisted_92 = {
  key: 4,
  class: "row g-3"
}
const _hoisted_93 = { class: "border rounded p-3 d-flex align-items-center justify-content-between" }
const _hoisted_94 = { class: "text-muted" }
const _hoisted_95 = ["onClick"]
const _hoisted_96 = { class: "d-flex justify-content-between mt-4 mb-4" }
const _hoisted_97 = { class: "d-flex gap-3" }
const _hoisted_98 = { class: "d-flex gap-3" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = {
  key: 0,
  class: "fa fa-spinner fa-spin me-2"
}
const _hoisted_101 = {
  key: 1,
  class: "fa fa-save me-2"
}
const _hoisted_102 = ["disabled"]
const _hoisted_103 = {
  key: 0,
  class: "fa fa-spinner fa-spin me-2"
}
const _hoisted_104 = {
  key: 1,
  class: "fa fa-paper-plane me-2"
}
const _hoisted_105 = {
  key: 0,
  class: "modal-backdrop fade show"
}
const _hoisted_106 = {
  key: 1,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"z-index":"1050"}
}
const _hoisted_107 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_108 = {
  class: "modal-content overflow-hidden",
  style: {"border-radius":"20px","box-shadow":"0 25px 50px rgba(0, 0, 0, 0.15)"}
}
const _hoisted_109 = { class: "payment-modal-container" }
const _hoisted_110 = { class: "payment-header" }
const _hoisted_111 = { class: "amount-display" }
const _hoisted_112 = { class: "px-4 pb-4" }
const _hoisted_113 = { class: "alert alert-info mb-4" }
const _hoisted_114 = { class: "mb-2" }
const _hoisted_115 = { class: "row small" }
const _hoisted_116 = { class: "col-md-6" }
const _hoisted_117 = { class: "mb-1" }
const _hoisted_118 = { class: "mb-1" }
const _hoisted_119 = { class: "col-md-6" }
const _hoisted_120 = { class: "mb-1" }
const _hoisted_121 = {
  key: 0,
  class: "alert alert-success small p-3 mb-4"
}
const _hoisted_122 = { class: "payment-methods-grid" }
const _hoisted_123 = { class: "payment-method-desc" }
const _hoisted_124 = {
  key: 1,
  class: "alert alert-warning mt-4"
}
const _hoisted_125 = { class: "text-center mt-5" }
const _hoisted_126 = {
  key: 2,
  class: "modal-backdrop fade show"
}
const _hoisted_127 = {
  key: 3,
  class: "modal fade show d-block",
  tabindex: "-1"
}
const _hoisted_128 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_129 = { class: "modal-content" }
const _hoisted_130 = { class: "modal-body text-center p-4" }
const _hoisted_131 = { class: "d-flex flex-column gap-3" }
const _hoisted_132 = ["disabled"]
const _hoisted_133 = {
  key: 0,
  class: "fa fa-spinner fa-spin me-2"
}
const _hoisted_134 = {
  key: 1,
  class: "fa fa-print me-2"
}
const _hoisted_135 = ["disabled"]
const _hoisted_136 = {
  key: 0,
  class: "fa fa-spinner fa-spin me-2"
}
const _hoisted_137 = {
  key: 1,
  class: "fa fa-file-invoice-dollar me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StepProgressTracker = _resolveComponent("StepProgressTracker")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_StepProgressTracker, {
          "current-step": 'final',
          "besc-id": _ctx.bescId
        }, null, 8, ["besc-id"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_4, " Étape 4/4 – Récapitulatif et Soumission – " + _toDisplayString(_ctx.besc.refbesc || 'Chargement...'), 1),
            _createElementVNode("small", _hoisted_5, " Référence : " + _toDisplayString(_ctx.besc.refbesc) + " . Créé le " + _toDisplayString(_ctx.formatDate(_ctx.besc.createdAt)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[46] || (_cache[46] = _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, "Informations générales")
          ], -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Numéro de connaissement", -1)),
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.besc.numeroConnaissement || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Pays d'origine", -1)),
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.besc.paysOrigine?.name_fr || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Incoterm", -1)),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.besc.incoterm?.code || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Type de paiement fret", -1)),
              _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.besc.typeFret?.libelle || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Destination finale", -1)),
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.besc.destinationFinalePays?.name_fr || '-'), 1)
            ])
          ]),
          _cache[47] || (_cache[47] = _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, "Parties prenantes")
          ], -1)),
          _createElementVNode("div", _hoisted_18, [
            (_ctx.importateur)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Expéditeur", -1)),
                  _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.importateur.acteur.nomComplet || '-'), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.importateur)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Importateur", -1)),
                  _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.importateur.acteur.nomComplet || '-'), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.transitaire)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Transitaire", -1)),
                  _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.transitaire.acteur.nomComplet || '-'), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.partieANotifier)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Partie à notifier", -1)),
                  _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.partieANotifier.acteur.nomComplet || '-'), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[48] || (_cache[48] = _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, "Transport & itinéraire")
          ], -1)),
          _createElementVNode("div", _hoisted_27, [
            (_ctx.transporteur)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Transporteur", -1)),
                  _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.transporteur.acteur.nomComplet || '-'), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              _cache[23] || (_cache[23] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Navire", -1)),
              _createElementVNode("p", _hoisted_31, [
                _createTextVNode(_toDisplayString(_ctx.besc.vessel?.name || '-') + " ", 1),
                (_ctx.besc.vessel?.imo)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_32, "(IMO: " + _toDisplayString(_ctx.besc.vessel.imo) + ")", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _cache[24] || (_cache[24] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Port de chargement", -1)),
              _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.besc.portChargement?.nomPort || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_35, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Port de déchargement", -1)),
              _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.besc.portDechargement?.nomPort || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _cache[26] || (_cache[26] = _createElementVNode("label", { class: "text-black fw-semibold" }, "ETD (Départ estimé)", -1)),
              _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.formatDate(_ctx.besc.etd)), 1)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _cache[27] || (_cache[27] = _createElementVNode("label", { class: "text-black fw-semibold" }, "ETA (Arrivée estimée)", -1)),
              _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.formatDate(_ctx.besc.eta)), 1)
            ]),
            (_ctx.besc.transbordement === 'oui')
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  (_ctx.transbordement)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _cache[28] || (_cache[28] = _createElementVNode("strong", null, "Transbordement :", -1)),
                        _cache[29] || (_cache[29] = _createTextVNode(" Oui", -1)),
                        _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" Navire après transbordement : " + _toDisplayString(_ctx.besc.navireApresTransbordement?.name || '-'), 1),
                        _cache[31] || (_cache[31] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" Transporteur après transbordement : " + _toDisplayString(_ctx.transbordement.acteur.nomComplet || '-' || '-'), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("h5", _hoisted_44, " Marchandises (" + _toDisplayString(_ctx.totalMarchandises) + ") ", 1)
          ]),
          (_ctx.besc.bls?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.besc.bls, (bl, blIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: blIndex,
                      class: "accordion-item border mb-3 shadow-sm"
                    }, [
                      _createElementVNode("h2", _hoisted_47, [
                        _createElementVNode("button", {
                          class: "accordion-button collapsed bg-blue-header text-white fw-bold",
                          type: "button",
                          "data-bs-toggle": 'collapse',
                          "data-bs-target": '#bl' + blIndex,
                          "aria-expanded": blIndex === 0 ? 'true' : 'false',
                          "aria-controls": 'bl' + blIndex
                        }, [
                          _cache[32] || (_cache[32] = _createElementVNode("i", { class: "fas fa-file-alt me-3" }, null, -1)),
                          _createTextVNode(" BL N° " + _toDisplayString(bl.blNumber) + " ", 1),
                          _createElementVNode("span", _hoisted_49, _toDisplayString(bl.bescLignes?.length || 0) + " marchandise(s) ", 1),
                          (bl.conteneurs?.length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(bl.conteneurs.length) + " conteneur(s) ", 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_48)
                      ]),
                      _createElementVNode("div", {
                        id: 'bl' + blIndex,
                        class: _normalizeClass(["accordion-collapse collapse", { show: blIndex === 0 }]),
                        "data-bs-parent": "#blAccordion"
                      }, [
                        _createElementVNode("div", _hoisted_52, [
                          (bl.bescLignes?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                _cache[34] || (_cache[34] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center mb-3 border-bottom pb-2" }, [
                                  _createElementVNode("h6", { class: "text-primary fw-bold mb-0" }, [
                                    _createElementVNode("i", { class: "fas fa-boxes me-2" }),
                                    _createTextVNode("Détail des marchandises ")
                                  ]),
                                  _createElementVNode("div", { class: "dropdown" })
                                ], -1)),
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("table", _hoisted_55, [
                                    _cache[33] || (_cache[33] = _createElementVNode("thead", {
                                      style: {"background-color":"#0a59a4"},
                                      class: "text-white"
                                    }, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, "Description"),
                                        _createElementVNode("th", { class: "text-center" }, "Qté"),
                                        _createElementVNode("th", { class: "text-center" }, "Nb Colis"),
                                        _createElementVNode("th", { class: "text-end" }, "Val. comm."),
                                        _createElementVNode("th", { class: "text-end" }, "Val. déclarée"),
                                        _createElementVNode("th", { class: "text-end" }, "Poids brut"),
                                        _createElementVNode("th", { class: "text-end" }, "Poids net"),
                                        _createElementVNode("th", { class: "text-end" }, "Volume")
                                      ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bl.bescLignes, (ligne) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: ligne.id
                                        }, [
                                          _createElementVNode("td", null, _toDisplayString(ligne.descriptionMarchandise || '-'), 1),
                                          _createElementVNode("td", _hoisted_56, _toDisplayString(ligne.quantite || '-'), 1),
                                          _createElementVNode("td", _hoisted_57, _toDisplayString(ligne.nombreColis || '-'), 1),
                                          _createElementVNode("td", _hoisted_58, _toDisplayString(_ctx.formatNumber(ligne.valeurCommerciale)) + " " + _toDisplayString(ligne.devise || 'USD'), 1),
                                          _createElementVNode("td", _hoisted_59, _toDisplayString(_ctx.formatNumber(ligne.valeurDeclaree)) + " " + _toDisplayString(ligne.devise || 'USD'), 1),
                                          _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.formatNumber(ligne.poidsBrut)) + " kg", 1),
                                          _createElementVNode("td", _hoisted_61, _toDisplayString(_ctx.formatNumber(ligne.poidsNet)) + " kg", 1),
                                          _createElementVNode("td", _hoisted_62, _toDisplayString(_ctx.formatNumber(ligne.volume)) + " m³", 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (bl.conteneurs?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.showConteneurs(bl.conteneurs, bl.blNumber)),
                                  class: "btn btn-primary btn-lg"
                                }, [
                                  _cache[35] || (_cache[35] = _createElementVNode("i", { class: "fas fa-box me-2" }, null, -1)),
                                  _createTextVNode(" Voir les " + _toDisplayString(bl.conteneurs.length) + " conteneur(s) ", 1)
                                ], 8, _hoisted_64)
                              ]))
                            : _createCommentVNode("", true),
                          (!bl.bescLignes?.length && !bl.conteneurs?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [...(_cache[36] || (_cache[36] = [
                                _createElementVNode("i", { class: "fas fa-inbox fa-2x mb-2 opacity-50" }, null, -1),
                                _createElementVNode("p", { class: "mb-0" }, "Aucune marchandise ni conteneur pour ce BL.", -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ])
                      ], 10, _hoisted_51)
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_66, [...(_cache[37] || (_cache[37] = [
                _createElementVNode("i", { class: "fas fa-inbox fa-3x mb-3 opacity-50" }, null, -1),
                _createElementVNode("p", { class: "mb-0" }, "Aucun BL enregistré.", -1)
              ]))])),
          (_ctx.showConteneursModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "modal-backdrop fade show",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showConteneursModal = false))
              }))
            : _createCommentVNode("", true),
          (_ctx.showConteneursModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("h5", _hoisted_71, [
                        _cache[38] || (_cache[38] = _createElementVNode("i", { class: "fas fa-box me-2" }, null, -1)),
                        _createTextVNode(" Conteneurs du BL N° " + _toDisplayString(_ctx.selectedBlNumber), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close btn-close-white",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showConteneursModal = false))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedConteneurs, (conteneur, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: conteneur.id,
                            class: "col-md-6"
                          }, [
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("div", _hoisted_75, [
                                _cache[39] || (_cache[39] = _createElementVNode("i", { class: "fas fa-cube me-2" }, null, -1)),
                                _createTextVNode(" Conteneur " + _toDisplayString(index + 1), 1)
                              ]),
                              _createElementVNode("div", _hoisted_76, [
                                _createElementVNode("div", _hoisted_77, [
                                  _cache[40] || (_cache[40] = _createElementVNode("label", { class: "text-muted small fw-semibold d-block mb-1" }, [
                                    _createElementVNode("i", { class: "fas fa-barcode me-1" }),
                                    _createTextVNode("Numéro de conteneur ")
                                  ], -1)),
                                  _createElementVNode("p", _hoisted_78, _toDisplayString(conteneur.numeroConteneur || 'Non renseigné'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_79, [
                                  _createElementVNode("div", _hoisted_80, [
                                    _cache[41] || (_cache[41] = _createElementVNode("label", { class: "text-muted small fw-semibold d-block mb-1" }, [
                                      _createElementVNode("i", { class: "fas fa-lock me-1" }),
                                      _createTextVNode("N° Scellé ")
                                    ], -1)),
                                    (conteneur.numeroScelle)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_81, _toDisplayString(conteneur.numeroScelle), 1))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_82, " Non renseigné "))
                                  ]),
                                  _createElementVNode("div", _hoisted_83, [
                                    _cache[42] || (_cache[42] = _createElementVNode("label", { class: "text-muted small fw-semibold d-block mb-1" }, [
                                      _createElementVNode("i", { class: "fas fa-weight-hanging me-1" }),
                                      _createTextVNode("Poids brut ")
                                    ], -1)),
                                    (conteneur.poidsBrut)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_84, _toDisplayString(_ctx.formatNumber(conteneur.poidsBrut)) + " kg ", 1))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_85, " Non renseigné "))
                                  ]),
                                  _createElementVNode("div", _hoisted_86, [
                                    _cache[43] || (_cache[43] = _createElementVNode("label", { class: "text-muted small fw-semibold d-block mb-1" }, [
                                      _createElementVNode("i", { class: "fas fa-cube me-1" }),
                                      _createTextVNode("Volume ")
                                    ], -1)),
                                    (conteneur.volume)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_87, _toDisplayString(_ctx.formatNumber(conteneur.volume)) + " m³ ", 1))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_88, " Non renseigné "))
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showConteneursModal = false))
                      }, [...(_cache[44] || (_cache[44] = [
                        _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1),
                        _createTextVNode(" Fermer ", -1)
                      ]))])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("h5", _hoisted_91, "Documents joints (" + _toDisplayString(_ctx.besc.documents?.length || 0) + ")", 1)
          ]),
          (_ctx.besc.documents?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.besc.documents, (doc) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-md-4",
                    key: doc.id
                  }, [
                    _createElementVNode("div", _hoisted_93, [
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString(doc.typeDocument?.libelle || 'Document'), 1),
                        _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("small", _hoisted_94, _toDisplayString(doc.filename), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-primary",
                        onClick: ($event: any) => (_ctx.openDocument(_ctx.bescId, doc.id))
                      }, " Voir ", 8, _hoisted_95)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_96, [
      _createElementVNode("div", _hoisted_97, [
        _createVNode(_component_router_link, {
          to: "/liste-besc",
          class: "btn btn-outline-secondary px-4"
        }, {
          default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
            _createElementVNode("i", { class: "fa fa-times me-2" }, null, -1),
            _createTextVNode(" Annuler ", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: { name: 'EditAddBescStep3', params: { id: _ctx.bescId } },
          class: "btn btn-outline-danger px-4"
        }, {
          default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
            _createElementVNode("i", { class: "fa fa-arrow-left me-2" }, null, -1),
            _createTextVNode(" Retour à l'étape 3 ", -1)
          ]))]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_98, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveDraftOnly && _ctx.saveDraftOnly(...args))),
          class: "btn btn-outline-primary px-4",
          disabled: _ctx.submitting || !_ctx.hasAllDocuments
        }, [
          (_ctx.submitting && _ctx.actionType === 'draft')
            ? (_openBlock(), _createElementBlock("i", _hoisted_100))
            : (_openBlock(), _createElementBlock("i", _hoisted_101)),
          _createTextVNode(" " + _toDisplayString(_ctx.submitting && _ctx.actionType === 'draft' ? 'Enregistrement...' : 'Enregistrer brouillon'), 1)
        ], 8, _hoisted_99),
        (_ctx.besc.facture?.status !== 'PAID')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveDraft && _ctx.saveDraft(...args))),
              class: "btn btn-primary px-4",
              disabled: _ctx.submitting || !_ctx.hasAllDocuments
            }, [
              (_ctx.submitting && _ctx.actionType === 'submit')
                ? (_openBlock(), _createElementBlock("i", _hoisted_103))
                : (_openBlock(), _createElementBlock("i", _hoisted_104)),
              _createTextVNode(" " + _toDisplayString(_ctx.submitting && _ctx.actionType === 'submit' ? 'Soumission...' : 'Soumettre le BESC'), 1)
            ], 8, _hoisted_102))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.showPaymentModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_105))
      : _createCommentVNode("", true),
    (_ctx.showPaymentModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("div", _hoisted_110, [
                  _cache[51] || (_cache[51] = _createElementVNode("h2", null, "Finaliser votre BESC", -1)),
                  _cache[52] || (_cache[52] = _createElementVNode("p", null, "Paiement sécurisé et rapide", -1)),
                  _createElementVNode("div", _hoisted_111, _toDisplayString(_ctx.formatAmount(_ctx.facture?.montantTotal || 0)) + " EUROS ", 1)
                ]),
                _createElementVNode("div", _hoisted_112, [
                  _createElementVNode("div", _hoisted_113, [
                    _createElementVNode("h6", _hoisted_114, " Facture : " + _toDisplayString(_ctx.facture?.referenceFacture), 1),
                    _createElementVNode("div", _hoisted_115, [
                      _createElementVNode("div", _hoisted_116, [
                        _createElementVNode("p", _hoisted_117, [
                          _cache[53] || (_cache[53] = _createElementVNode("strong", null, "Montant HT :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.formatAmount(_ctx.facture?.subtotalAmount)) + " EUROS", 1)
                        ]),
                        _createElementVNode("p", _hoisted_118, [
                          _cache[54] || (_cache[54] = _createElementVNode("strong", null, "TVA (18%) :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.formatAmount(_ctx.facture?.taxAmount)) + " EUROS", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("p", _hoisted_120, [
                          _cache[55] || (_cache[55] = _createElementVNode("strong", null, "Échéance :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.formatDate(_ctx.facture?.dueDate)), 1)
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.prepaidAccount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_121, [
                        _cache[56] || (_cache[56] = _createElementVNode("strong", null, "Solde disponible :", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatAmount(_ctx.prepaidAccount.balance)) + " EUROS ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  _cache[64] || (_cache[64] = _createElementVNode("div", { class: "payment-methods-title" }, " Choisissez votre moyen de paiement ", -1)),
                  _createElementVNode("div", _hoisted_122, [
                    (_ctx.prepaidAccount && _ctx.prepaidAccount.balance >= _ctx.facture?.montantTotal)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "payment-method-card recommended",
                          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.payWithPrepaidAccount && _ctx.payWithPrepaidAccount(...args))),
                          style: {"cursor":"pointer"}
                        }, [
                          _cache[57] || (_cache[57] = _createElementVNode("div", { class: "payment-icon-wrapper" }, [
                            _createElementVNode("i", { class: "fa fa-wallet fa-3x text-primary" })
                          ], -1)),
                          _cache[58] || (_cache[58] = _createElementVNode("div", { class: "payment-method-name" }, "Compte Prépayé", -1)),
                          _createElementVNode("div", _hoisted_123, "Solde : " + _toDisplayString(_ctx.formatAmount(_ctx.prepaidAccount.balance)) + " EUROS", 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "payment-method-card recommended",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.redirectToPaymentMethod('kkiapay'))),
                      style: {"cursor":"pointer"}
                    }, [...(_cache[59] || (_cache[59] = [
                      _createElementVNode("div", { class: "payment-icon-wrapper" }, [
                        _createElementVNode("img", {
                          src: "/kkiapay.png.webp",
                          alt: "KkiaPay",
                          style: {"width":"60px","height":"60px","object-fit":"contain"}
                        })
                      ], -1),
                      _createElementVNode("div", { class: "payment-method-name" }, "KkiaPay", -1),
                      _createElementVNode("div", { class: "payment-method-desc" }, "MTN • Moov • Carte", -1)
                    ]))]),
                    _createElementVNode("div", {
                      class: "payment-method-card",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.redirectToPaymentMethod('paypal'))),
                      style: {"cursor":"pointer"}
                    }, [...(_cache[60] || (_cache[60] = [
                      _createElementVNode("div", { class: "payment-icon-wrapper" }, [
                        _createElementVNode("img", {
                          src: "/paypal.png.png",
                          alt: "PayPal",
                          style: {"width":"60px","height":"60px","object-fit":"contain"}
                        })
                      ], -1),
                      _createElementVNode("div", { class: "payment-method-name" }, "PayPal", -1),
                      _createElementVNode("div", { class: "payment-method-desc" }, "Compte PayPal", -1)
                    ]))]),
                    _createElementVNode("div", {
                      class: "payment-method-card",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.redirectToPaymentMethod('stripe'))),
                      style: {"cursor":"pointer"}
                    }, [...(_cache[61] || (_cache[61] = [
                      _createElementVNode("div", { class: "payment-icon-wrapper" }, [
                        _createElementVNode("img", {
                          src: "/stripe.png.png",
                          alt: "Stripe",
                          style: {"width":"60px","height":"60px","object-fit":"contain"}
                        })
                      ], -1),
                      _createElementVNode("div", { class: "payment-method-name" }, "Carte Bancaire", -1),
                      _createElementVNode("div", { class: "payment-method-desc" }, "Visa • Mastercard", -1)
                    ]))])
                  ]),
                  (_ctx.prepaidAccount && _ctx.prepaidAccount.balance < _ctx.facture?.montantTotal)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                        _createElementVNode("small", null, [
                          _cache[62] || (_cache[62] = _createElementVNode("i", { class: "fa fa-info-circle me-1" }, null, -1)),
                          _createTextVNode(" Solde insuffisant. Manquant : " + _toDisplayString(_ctx.formatAmount(_ctx.facture.montantTotal - _ctx.prepaidAccount.balance)) + " EUROS ", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_125, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-secondary btn-lg me-2",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.cancelPayment && _ctx.cancelPayment(...args)))
                    }, [...(_cache[63] || (_cache[63] = [
                      _createElementVNode("i", { class: "fa fa-times me-2" }, null, -1),
                      _createTextVNode(" Annuler et revenir à la liste ", -1)
                    ]))])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSuccessModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_126))
      : _createCommentVNode("", true),
    (_ctx.showSuccessModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
          _createElementVNode("div", _hoisted_128, [
            _createElementVNode("div", _hoisted_129, [
              _cache[67] || (_cache[67] = _createElementVNode("div", {
                class: "modal-header",
                style: {"background-color":"#28a745"}
              }, [
                _createElementVNode("h5", { class: "modal-title text-white" }, [
                  _createElementVNode("i", { class: "fa fa-check-circle me-2" }),
                  _createTextVNode(" Paiement confirmé ! ")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_130, [
                _cache[66] || (_cache[66] = _createElementVNode("p", { class: "mb-4" }, [
                  _createTextVNode("Votre paiement a été confirmé avec succès."),
                  _createElementVNode("br"),
                  _createTextVNode("Imprimez vos documents maintenant :")
                ], -1)),
                _createElementVNode("div", _hoisted_131, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-success btn-lg",
                    onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.printBESC && _ctx.printBESC(...args))),
                    disabled: _ctx.printingBESC
                  }, [
                    (_ctx.printingBESC)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_133))
                      : (_openBlock(), _createElementBlock("i", _hoisted_134)),
                    _createTextVNode(" " + _toDisplayString(_ctx.printingBESC ? 'Préparation de l\'impression...' : 'Imprimer le BESC'), 1)
                  ], 8, _hoisted_132),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-info btn-lg text-white",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.printFacture && _ctx.printFacture(...args))),
                    disabled: _ctx.printingFacture
                  }, [
                    (_ctx.printingFacture)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_136))
                      : (_openBlock(), _createElementBlock("i", _hoisted_137)),
                    _createTextVNode(" " + _toDisplayString(_ctx.printingFacture ? 'Préparation de l\'impression...' : 'Imprimer la facture'), 1)
                  ], 8, _hoisted_135),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-outline-primary btn-lg",
                    onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.goToList && _ctx.goToList(...args)))
                  }, [...(_cache[65] || (_cache[65] = [
                    _createElementVNode("i", { class: "fa fa-list me-2" }, null, -1),
                    _createTextVNode(" Voir la liste des BESC ", -1)
                  ]))])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}